webpackJsonp([220250618448524],{

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Jump = factory());
	}(this, (function () { 'use strict';
	
	// Robert Penner's easeInOutQuad
	
	// find the rest of his easing functions here: http://robertpenner.com/easing/
	// find them exported for ES6 consumption here: https://github.com/jaxgeller/ez.js
	
	var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
	  t /= d / 2;
	  if (t < 1) return c / 2 * t * t + b;
	  t--;
	  return -c / 2 * (t * (t - 2) - 1) + b;
	};
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var jumper = function jumper() {
	  // private variable cache
	  // no variables are created during a jump, preventing memory leaks
	
	  var element = void 0; // element to scroll to                   (node)
	
	  var start = void 0; // where scroll starts                    (px)
	  var stop = void 0; // where scroll stops                     (px)
	
	  var offset = void 0; // adjustment from the stop position      (px)
	  var easing = void 0; // easing function                        (function)
	  var a11y = void 0; // accessibility support flag             (boolean)
	
	  var distance = void 0; // distance of scroll                     (px)
	  var duration = void 0; // scroll duration                        (ms)
	
	  var timeStart = void 0; // time scroll started                    (ms)
	  var timeElapsed = void 0; // time spent scrolling thus far          (ms)
	
	  var next = void 0; // next scroll position                   (px)
	
	  var callback = void 0; // to call when done scrolling            (function)
	
	  // scroll position helper
	
	  function location() {
	    return window.scrollY || window.pageYOffset;
	  }
	
	  // element offset helper
	
	  function top(element) {
	    return element.getBoundingClientRect().top + start;
	  }
	
	  // rAF loop helper
	
	  function loop(timeCurrent) {
	    // store time scroll started, if not started already
	    if (!timeStart) {
	      timeStart = timeCurrent;
	    }
	
	    // determine time spent scrolling so far
	    timeElapsed = timeCurrent - timeStart;
	
	    // calculate next scroll position
	    next = easing(timeElapsed, start, distance, duration);
	
	    // scroll to it
	    window.scrollTo(0, next);
	
	    // check progress
	    timeElapsed < duration ? window.requestAnimationFrame(loop) // continue scroll loop
	    : done(); // scrolling is done
	  }
	
	  // scroll finished helper
	
	  function done() {
	    // account for rAF time rounding inaccuracies
	    window.scrollTo(0, start + distance);
	
	    // if scrolling to an element, and accessibility is enabled
	    if (element && a11y) {
	      // add tabindex indicating programmatic focus
	      element.setAttribute('tabindex', '-1');
	
	      // focus the element
	      element.focus();
	    }
	
	    // if it exists, fire the callback
	    if (typeof callback === 'function') {
	      callback();
	    }
	
	    // reset time for next jump
	    timeStart = false;
	  }
	
	  // API
	
	  function jump(target) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    // resolve options, or use defaults
	    duration = options.duration || 1000;
	    offset = options.offset || 0;
	    callback = options.callback; // "undefined" is a suitable default, and won't be called
	    easing = options.easing || easeInOutQuad;
	    a11y = options.a11y || false;
	
	    // cache starting position
	    start = location();
	
	    // resolve target
	    switch (typeof target === 'undefined' ? 'undefined' : _typeof(target)) {
	      // scroll from current position
	      case 'number':
	        element = undefined; // no element to scroll to
	        a11y = false; // make sure accessibility is off
	        stop = start + target;
	        break;
	
	      // scroll to element (node)
	      // bounding rect is relative to the viewport
	      case 'object':
	        element = target;
	        stop = top(element);
	        break;
	
	      // scroll to element (selector)
	      // bounding rect is relative to the viewport
	      case 'string':
	        element = document.querySelector(target);
	        stop = top(element);
	        break;
	    }
	
	    // resolve scroll distance, accounting for offset
	    distance = stop - start + offset;
	
	    // resolve duration
	    switch (_typeof(options.duration)) {
	      // number in ms
	      case 'number':
	        duration = options.duration;
	        break;
	
	      // function passed the distance of the scroll
	      case 'function':
	        duration = options.duration(distance);
	        break;
	    }
	
	    // start the loop
	    window.requestAnimationFrame(loop);
	  }
	
	  // expose only the jump method
	  return jump;
	};
	
	// export singleton
	
	var singleton = jumper();
	
	return singleton;
	
	})));


/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var invariant = _interopDefault(__webpack_require__(48));
	
	var INSTANCE_MAP = new Map();
	var OBSERVER_MAP = new Map();
	
	/**
	 * Monitor element, and trigger callback when element becomes visible
	 * @param element {HTMLElement}
	 * @param callback {Function} Called with inView
	 * @param options {Object} InterSection observer options
	 * @param options.threshold {Number} Number between 0 and 1, indicating how much of the element should be visible before triggering
	 * @param options.root {HTMLElement} It should have a unique id or data-intersection-id in order for the Observer to reused.
	 * @param options.rootMargin {String} The CSS margin to apply to the root element.
	 * @param rootId {String} Unique identifier for the root element, to enable reusing the IntersectionObserver
	 */
	function observe(element, callback) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    threshold: 0
	  };
	  var rootId = arguments[3];
	  var root = options.root,
	      rootMargin = options.rootMargin;
	
	  var threshold = options.threshold || 0;
	  if (!element || !callback) return;
	  var observerId = rootMargin ? threshold.toString() + "_" + rootMargin : "" + threshold.toString();
	
	  if (root) {
	    observerId = rootId ? rootId + "_" + observerId : null;
	  }
	
	  var observerInstance = observerId ? OBSERVER_MAP.get(observerId) : null;
	  if (!observerInstance) {
	    observerInstance = new IntersectionObserver(onChange, options);
	    if (observerId) OBSERVER_MAP.set(observerId, observerInstance);
	  }
	
	  var instance = {
	    callback: callback,
	    visible: false,
	    options: options,
	    observerId: observerId,
	    observer: !observerId ? observerInstance : undefined
	  };
	
	  INSTANCE_MAP.set(element, instance);
	
	  observerInstance.observe(element);
	
	  return instance;
	}
	
	/**
	 * Stop observing an element. If an element is removed from the DOM or otherwise destroyed,
	 * make sure to call this method.
	 * @param element {HTMLElement}
	 */
	function unobserve(element) {
	  if (!element) return;
	  var instance = INSTANCE_MAP.get(element);
	
	  if (instance) {
	    var _observerId = instance.observerId,
	        _observer = instance.observer;
	
	    var observerInstance = _observerId ? OBSERVER_MAP.get(_observerId) : _observer;
	
	    if (observerInstance) {
	      // $FlowFixMe - the interface in bom.js is wrong. Spec should accept the element.
	      observerInstance.unobserve(element);
	    }
	
	    // Check if we are still observing any elements with the same threshold.
	    var itemsLeft = false;
	    if (_observerId) {
	      INSTANCE_MAP.forEach(function (item, key) {
	        if (item && item.observerId === _observerId && key !== element) {
	          itemsLeft = true;
	        }
	      });
	    }
	
	    if (observerInstance && !itemsLeft) {
	      // No more elements to observe for threshold, disconnect observer
	      observerInstance.disconnect();
	      OBSERVER_MAP.delete(_observerId);
	    }
	
	    // Remove reference to element
	    INSTANCE_MAP.delete(element);
	  }
	}
	
	function onChange(changes) {
	  changes.forEach(function (intersection) {
	    var isIntersecting = intersection.isIntersecting,
	        intersectionRatio = intersection.intersectionRatio,
	        target = intersection.target;
	
	    var instance = INSTANCE_MAP.get(target);
	
	    // Firefox can report a negative intersectionRatio when scrolling.
	    if (instance && intersectionRatio >= 0) {
	      var _options = instance.options;
	
	      var _inView = false;
	
	      if (Array.isArray(_options.threshold)) {
	        // If threshold is an array, check if any of them intersects. This just triggers the onChange event multiple times.
	        _inView = _options.threshold.some(function (threshold) {
	          return instance.visible ? intersectionRatio > threshold : intersectionRatio >= threshold;
	        });
	      } else if (_options.threshold !== undefined) {
	        // Trigger on 0 ratio only when not visible. This is fallback for browsers without isIntersecting support
	        _inView = instance.visible ? intersectionRatio > _options.threshold : intersectionRatio >= _options.threshold;
	      }
	
	      if (isIntersecting !== undefined) {
	        // If isIntersecting is defined, ensure that the element is actually intersecting.
	        // Otherwise it reports a threshold of 0
	        _inView = _inView && isIntersecting;
	      }
	
	      instance.visible = _inView;
	      if (instance.callback) {
	        instance.callback(_inView);
	      }
	    }
	  });
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	/**
	 * Monitors scroll, and triggers the children function with updated props
	 *
	 <Observer>
	 {inView => (
	   <h1>{`${inView}`}</h1>
	 )}
	 </Observer>
	 */
	var Observer = function (_React$Component) {
	  inherits(Observer, _React$Component);
	
	  function Observer() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Observer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      inView: false
	    }, _this.node = null, _this.handleNode = function (node) {
	      if (_this.node) unobserve(_this.node);
	      _this.node = node;
	      _this.observeNode();
	    }, _this.handleChange = function (inView) {
	      _this.setState({ inView: inView });
	      if (_this.props.onChange) {
	        _this.props.onChange(inView);
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Observer.prototype.componentDidMount = function componentDidMount() {
	    if (typeof this.props.render === 'function') {
	      invariant(this.node, 'react-intersection-observer: No DOM node found. Make sure you forward "ref" to the root DOM element you want to observe, when using render prop.');
	    }
	  };
	
	  Observer.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // If a IntersectionObserver option changed, reinit the observer
	    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold) {
	      unobserve(this.node);
	      this.observeNode();
	    }
	
	    if (prevState.inView !== this.state.inView) {
	      if (this.state.inView && this.props.triggerOnce) {
	        unobserve(this.node);
	        this.node = null;
	      }
	    }
	  };
	
	  Observer.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.node) {
	      unobserve(this.node);
	      this.node = null;
	    }
	  };
	
	  Observer.prototype.observeNode = function observeNode() {
	    if (!this.node) return;
	    var _props = this.props,
	        threshold = _props.threshold,
	        root = _props.root,
	        rootMargin = _props.rootMargin,
	        rootId = _props.rootId;
	
	    observe(this.node, this.handleChange, {
	      threshold: threshold,
	      root: root,
	      rootMargin: rootMargin
	    }, rootId);
	  };
	
	  Observer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        render = _props2.render,
	        tag = _props2.tag,
	        triggerOnce = _props2.triggerOnce,
	        threshold = _props2.threshold,
	        root = _props2.root,
	        rootId = _props2.rootId,
	        rootMargin = _props2.rootMargin,
	        props = objectWithoutProperties(_props2, ['children', 'render', 'tag', 'triggerOnce', 'threshold', 'root', 'rootId', 'rootMargin']);
	    var inView = this.state.inView;
	
	
	    if (typeof render === 'function') {
	      return render({ inView: inView, ref: this.handleNode });
	    }
	
	    return React.createElement(tag, _extends({}, props, {
	      ref: this.handleNode
	    }),
	    // If children is a function, render it with the current inView status.
	    // Otherwise always render children. Assume onChange is being used outside, to control the the state of children.
	    typeof children === 'function' ? children(inView) : children);
	  };
	
	  return Observer;
	}(React.Component);
	
	Observer.defaultProps = {
	  tag: 'div',
	  threshold: 0,
	  triggerOnce: false
	};
	
	module.exports = Observer;


/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function DefaultWrapper(_ref) {
	    var childProps = _ref.childProps,
	        children = _ref.children,
	        isFailed = _ref.isFailed,
	        isLoaded = _ref.isLoaded,
	        props = _objectWithoutProperties(_ref, ['childProps', 'children', 'isFailed', 'isLoaded']);
	
	    var className = 'react-lazy-wrapper' + (!isLoaded && !isFailed ? ' react-lazy-wrapper--' + (childProps ? 'loading' : 'placeholder') : '') + (isFailed ? ' react-lazy-wrapper--failed' : '') + (isLoaded ? ' react-lazy-wrapper--loaded' : '') + (props.className ? ' ' + props.className : '');
	
	    return _react2.default.createElement(
	        'div',
	        _extends({}, props, { className: className }),
	        children
	    );
	}
	
	exports.default = DefaultWrapper;

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Observer = __webpack_require__(162);
	
	var _Observer2 = _interopRequireDefault(_Observer);
	
	var _wrap = __webpack_require__(293);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Lazy = function (_React$PureComponent) {
	    _inherits(Lazy, _React$PureComponent);
	
	    function Lazy(props) {
	        _classCallCheck(this, Lazy);
	
	        var _this = _possibleConstructorReturn(this, (Lazy.__proto__ || Object.getPrototypeOf(Lazy)).call(this, props));
	
	        _this.state = { show: false };
	
	        _this.onViewport = _this.onViewport.bind(_this);
	        return _this;
	    }
	
	    _createClass(Lazy, [{
	        key: 'onViewport',
	        value: function onViewport(event, unobserve) {
	            var _props = this.props,
	                onLoad = _props.onLoad,
	                onViewport = _props.onViewport,
	                visible = _props.visible;
	
	
	            if (!visible) {
	                return;
	            }
	
	            if (!event.isIntersecting || event.defaultPrevented) {
	                return;
	            }
	
	            unobserve();
	
	            if (onViewport) {
	                onViewport(event);
	            }
	
	            this.setState({ show: true }, onLoad);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                children = _props2.children,
	                clientOnly = _props2.clientOnly,
	                component = _props2.component,
	                cushion = _props2.cushion,
	                ltIE9 = _props2.ltIE9,
	                visible = _props2.visible,
	                onLoad = _props2.onLoad,
	                onViewport = _props2.onViewport,
	                threshold = _props2.threshold,
	                viewport = _props2.viewport,
	                props = _objectWithoutProperties(_props2, ['children', 'clientOnly', 'component', 'cushion', 'ltIE9', 'visible', 'onLoad', 'onViewport', 'threshold', 'viewport']);
	
	            if (clientOnly || visible && this.state.show) {
	                return _react2.default.createElement(
	                    _Observer2.default,
	                    { cushion: cushion, onChange: this.onViewport, threshold: threshold, viewport: viewport },
	                    _react2.default.createElement(component, props, visible && this.state.show ? children : null)
	                );
	            }
	
	            // wrap all contents inside noscript
	            return _react2.default.createElement(
	                _Observer2.default,
	                { cushion: cushion, onChange: this.onViewport },
	                _react2.default.createElement(component, (0, _wrap.propsWithNoScriptRender)(children, ltIE9, props))
	            );
	        }
	    }]);
	
	    return Lazy;
	}(_react2.default.PureComponent);
	
	exports.default = Lazy;
	
	
	Lazy.defaultProps = {
	    clientOnly: false,
	    component: 'div',
	    ltIE9: false,
	    visible: true
	};

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LazyChild = function (_React$PureComponent) {
	    _inherits(LazyChild, _React$PureComponent);
	
	    function LazyChild(props) {
	        _classCallCheck(this, LazyChild);
	
	        var _this = _possibleConstructorReturn(this, (LazyChild.__proto__ || Object.getPrototypeOf(LazyChild)).call(this, props));
	
	        var _ref = props.children && (props.children.props || props.children._store && props.children._store.props) || {},
	            onError = _ref.onError,
	            onLoad = _ref.onLoad,
	            childProps = _objectWithoutProperties(_ref, ['onError', 'onLoad']);
	
	        _this.childOnError = onError;
	        _this.childOnLoad = onLoad;
	        _this.childProps = childProps;
	
	        _this.state = { isFailed: false, isLoaded: false };
	
	        _this.onError = _this.onError.bind(_this);
	        _this.onLoad = _this.onLoad.bind(_this);
	        return _this;
	    }
	
	    _createClass(LazyChild, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.children === this.props.children) {
	                return;
	            }
	
	            var _ref2 = this.props.children && (this.props.children.props || this.props.children._store && this.props.children._store.props) || {},
	                onError = _ref2.onError,
	                onLoad = _ref2.onLoad,
	                childProps = _objectWithoutProperties(_ref2, ['onError', 'onLoad']);
	
	            this.childOnError = onError;
	            this.childOnLoad = onLoad;
	            this.childProps = childProps;
	        }
	    }, {
	        key: 'onError',
	        value: function onError(event) {
	            this.setState({ isFailed: true }, this.props.callback);
	
	            if (this.childOnError) {
	                this.childOnError(event);
	            }
	        }
	    }, {
	        key: 'onLoad',
	        value: function onLoad(event) {
	            this.setState({ isLoaded: true }, this.props.callback);
	
	            if (this.childOnLoad) {
	                this.childOnLoad(event);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                callback = _props.callback,
	                children = _props.children,
	                wrapper = _props.wrapper,
	                props = _objectWithoutProperties(_props, ['callback', 'children', 'wrapper']);
	
	            var child = _react2.default.Children.only(children);
	
	            return _react2.default.createElement(wrapper, _extends({}, props, this.state, { childProps: this.childProps }), !this.state.isFailed && !this.state.isLoaded ? _react2.default.cloneElement(child, { onError: this.onError, onLoad: this.onLoad }) : child);
	        }
	    }]);
	
	    return LazyChild;
	}(_react2.default.PureComponent);
	
	exports.default = LazyChild;

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _wrap = __webpack_require__(293);
	
	var _DefaultWrapper = __webpack_require__(411);
	
	var _DefaultWrapper2 = _interopRequireDefault(_DefaultWrapper);
	
	var _Observer = __webpack_require__(162);
	
	var _Observer2 = _interopRequireDefault(_Observer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LazyGroup = function (_React$PureComponent) {
	    _inherits(LazyGroup, _React$PureComponent);
	
	    function LazyGroup(props) {
	        _classCallCheck(this, LazyGroup);
	
	        var _this = _possibleConstructorReturn(this, (LazyGroup.__proto__ || Object.getPrototypeOf(LazyGroup)).call(this, props));
	
	        _this.loadedImgTags = 0;
	        _this.state = { imgTagCount: null, loadedAt: null, viewportAt: null };
	
	        _this.onImgLoaded = _this.onImgLoaded.bind(_this);
	        _this.onViewport = _this.onViewport.bind(_this);
	        return _this;
	    }
	
	    _createClass(LazyGroup, [{
	        key: 'onImgLoaded',
	        value: function onImgLoaded() {
	            this.loadedImgTags++;
	
	            if (this.loadedImgTags === this.state.imgTagCount) {
	                this.loadedImgTags = 0;
	                this.setState({ imgTagCount: null, loadedAt: Date.now() }, this.props.onLoad);
	            }
	        }
	    }, {
	        key: 'onViewport',
	        value: function onViewport(event, unobserve) {
	            var _props = this.props,
	                children = _props.children,
	                childrenToWrap = _props.childrenToWrap,
	                onLoad = _props.onLoad,
	                onViewport = _props.onViewport,
	                visible = _props.visible;
	
	
	            if (!visible) {
	                return false;
	            }
	
	            if (!event.isIntersecting || event.defaultPrevented) {
	                return;
	            }
	
	            unobserve();
	
	            var imgTagCount = (0, _wrap.countTypesTags)(childrenToWrap, children) || null;
	            this.loadedImgTags = 0;
	            if (onViewport) {
	                onViewport(event);
	            }
	            var viewportAt = Date.now();
	            this.setState({ imgTagCount: imgTagCount, loadedAt: !imgTagCount ? viewportAt : null, viewportAt: viewportAt }, !imgTagCount ? onLoad : null);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                children = _props2.children,
	                childrenToWrap = _props2.childrenToWrap,
	                childWrapper = _props2.childWrapper,
	                clientOnly = _props2.clientOnly,
	                component = _props2.component,
	                cushion = _props2.cushion,
	                ltIE9 = _props2.ltIE9,
	                onLoad = _props2.onLoad,
	                onViewport = _props2.onViewport,
	                threshold = _props2.threshold,
	                viewport = _props2.viewport,
	                visible = _props2.visible,
	                props = _objectWithoutProperties(_props2, ['children', 'childrenToWrap', 'childWrapper', 'clientOnly', 'component', 'cushion', 'ltIE9', 'onLoad', 'onViewport', 'threshold', 'viewport', 'visible']);
	
	            return _react2.default.createElement(
	                _Observer2.default,
	                { cushion: cushion, onChange: this.onViewport, threshold: threshold, viewport: viewport },
	                _react2.default.createElement(component, props,
	                // swap render once element is visible in viewport
	                clientOnly || visible && this.state.viewportAt
	                // replace elements with LazyChild
	                ? (0, _wrap.wrapTypesToLazyChild)(childrenToWrap, children, childWrapper, this.onImgLoaded)
	                // wrap given element types to noscript and the given wrapper component
	                : (0, _wrap.wrapTypesToNoScript)(childrenToWrap, children, ltIE9, childWrapper))
	            );
	        }
	    }]);
	
	    return LazyGroup;
	}(_react2.default.PureComponent);
	
	exports.default = LazyGroup;
	
	
	LazyGroup.defaultProps = {
	    childrenToWrap: ['iframe', 'img'],
	    childWrapper: _DefaultWrapper2.default,
	    clientOnly: false,
	    component: 'div',
	    ltIE9: false,
	    visible: true
	};

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(69);
	
	var _intersectionObserver = __webpack_require__(413);
	
	var _utils = __webpack_require__(292);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // based on @researchgate/react-intersection-observer
	
	/* eslint-disable react/no-find-dom-node */
	
	
	var observerOptions = ['root', 'rootMargin', 'threshold'];
	var optToPropMapper = { root: 'viewport', rootMargin: 'cushion' };
	var observerProps = ['viewport', 'cushion', 'disabled'].concat(observerOptions);
	var objectProto = Object.prototype;
	
	var Observer = function (_React$Component) {
	    _inherits(Observer, _React$Component);
	
	    function Observer(props) {
	        _classCallCheck(this, Observer);
	
	        var _this = _possibleConstructorReturn(this, (Observer.__proto__ || Object.getPrototypeOf(Observer)).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleNode = _this.handleNode.bind(_this);
	        _this.observe = _this.observe.bind(_this);
	        _this.unobserve = _this.unobserve.bind(_this);
	        return _this;
	    }
	
	    _createClass(Observer, [{
	        key: 'handleChange',
	        value: function handleChange(event) {
	            this.props.onChange(event, this.unobserve);
	        }
	    }, {
	        key: 'handleNode',
	        value: function handleNode(target) {
	            if (typeof this.props.children.ref === 'function') {
	                this.props.children.ref(target);
	            }
	
	            if (this.renderedTarget && target && this.renderedTarget !== target) {
	                this.unobserve();
	                this.targetChanged = true;
	            } else {
	                this.targetChanged = false;
	            }
	
	            this.target = target;
	        }
	    }, {
	        key: 'observe',
	        value: function observe() {
	            var isDOMTypeElement = _react2.default.isValidElement(this.target) && typeof this.target.type === 'string';
	
	            if (!isDOMTypeElement) {
	                this.target = (0, _reactDom.findDOMNode)(this.target);
	            }
	
	            this.observer = (0, _intersectionObserver.createObserver)(this.options);
	            (0, _intersectionObserver.observeElement)(this);
	        }
	    }, {
	        key: 'unobserve',
	        value: function unobserve() {
	            if (this.target != null) {
	                (0, _intersectionObserver.unobserveElement)(this);
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (!this.props.disabled) {
	                this.observe();
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            var _this2 = this;
	
	            if (this.targetChanged || observerProps.some(function (option) {
	                return (0, _utils.shallowCompare)(_this2.props[option], prevProps[option]);
	            })) {
	                this.unobserve();
	
	                if (!this.props.disabled) {
	                    this.observe();
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.unobserve();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            this.renderedTarget = this.target;
	
	            return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), { ref: this.handleNode });
	        }
	    }, {
	        key: 'options',
	        get: function get() {
	            var props = this.props;
	
	            return observerOptions.reduce(function (options, option) {
	                var prop = optToPropMapper[option] || option;
	                // allow usage of root and rootMargin props, but prefer viewport and cushion
	                var key = objectProto.hasOwnProperty.call(props, prop) && prop || prop !== option && objectProto.hasOwnProperty.call(props, option) && option || '';
	
	                if (key) {
	                    var useQuery = option === 'root' && objectProto.toString.call(props[key]) === '[object String]';
	
	                    options[option] = useQuery ? document.querySelector(props[key]) : props[key];
	                }
	
	                return options;
	            }, {});
	        }
	    }]);
	
	    return Observer;
	}(_react2.default.Component);
	
	exports.default = Observer;

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Observer = exports.Lazy = exports.LazyGroup = undefined;
	
	var _LazyGroup2 = __webpack_require__(290);
	
	var _LazyGroup3 = _interopRequireDefault(_LazyGroup2);
	
	var _Lazy2 = __webpack_require__(289);
	
	var _Lazy3 = _interopRequireDefault(_Lazy2);
	
	var _Observer2 = __webpack_require__(162);
	
	var _Observer3 = _interopRequireDefault(_Observer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.LazyGroup = _LazyGroup3.default;
	exports.Lazy = _Lazy3.default;
	exports.Observer = _Observer3.default;

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.storage = undefined;
	exports.findObserverElement = findObserverElement;
	exports.getPooled = getPooled;
	exports.callback = callback;
	exports.createObserver = createObserver;
	exports.observeElement = observeElement;
	exports.unobserveElement = unobserveElement;
	
	var _utils = __webpack_require__(292);
	
	var storage = exports.storage = new Map(); // based on @researchgate/react-intersection-observer
	function findObserverElement(observer, entry) {
	    var observerElements = storage.get(observer);
	
	    if (observerElements) {
	        var elements = observerElements.values();
	
	        for (var element = elements.next(); !element.done; element = elements.next()) {
	            if (element.value.target === entry.target) {
	                return element.value;
	            }
	        }
	    }
	
	    return null;
	}
	
	function getPooled() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var root = options.root || null;
	    var rootMargin = (0, _utils.parseRootMargin)(options.rootMargin);
	    var threshold = Array.isArray(options.threshold) ? options.threshold : [options.threshold != null ? options.threshold : 0];
	
	    var observers = storage.keys();
	
	    for (var observer = observers.next(); !observer.done; observer = observers.next()) {
	        var unmatched = root !== observer.value.root || rootMargin !== observer.value.rootMargin || (0, _utils.shallowCompare)(threshold, observer.value.threshold);
	
	        if (!unmatched) {
	            return observer.value;
	        }
	    }
	
	    return null;
	}
	
	/**
	 * The Intersection Observer API callback that is called whenever one element,
	 * called the target, intersects either the device viewport or a specified element.
	 * Also will get called whenever the visibility of the target element changes and
	 * crosses desired amounts of intersection with the viewport element.
	 * @param {array} changes
	 * @param {IntersectionObserver} observer
	 */
	function callback(changes, observer) {
	    for (var i = 0; i < changes.length; i++) {
	        var instance = findObserverElement(observer, changes[i]);
	
	        if (instance) {
	            instance.handleChange(changes[i]);
	        }
	    }
	}
	
	function createObserver(options) {
	    return getPooled(options) || new IntersectionObserver(callback, options);
	}
	
	function observeElement(element) {
	    if (!storage.has(element.observer)) {
	        storage.set(element.observer, new Set());
	    }
	
	    storage.get(element.observer).add(element);
	    element.observer.observe(element.target);
	}
	
	function unobserveElement(element) {
	    if (storage.has(element.observer)) {
	        var targets = storage.get(element.observer);
	
	        if (targets.delete(element)) {
	            if (targets.size > 0) {
	                element.observer.unobserve(element.target);
	            } else {
	                element.observer.disconnect();
	                storage.delete(element.observer);
	            }
	        }
	    }
	}

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.parseRootMargin = parseRootMargin;
	exports.shallowCompare = shallowCompare;
	// from @researchgate/react-intersection-observer
	var marginRE = /^-?\d*\.?\d+(px|%)$/;
	
	function parseRootMargin(rootMargin) {
	    var marginString = rootMargin ? rootMargin.trim() : '0px';
	
	    var _marginString$split$m = marginString.split(/\s+/).map(function (margin) {
	        if (!marginRE.test(margin)) {
	            throw new Error('rootMargin must be a string literal containing pixels and/or percent values');
	        }
	
	        return margin;
	    }),
	        _marginString$split$m2 = _slicedToArray(_marginString$split$m, 4),
	        _marginString$split$m3 = _marginString$split$m2[0],
	        m0 = _marginString$split$m3 === undefined ? '0px' : _marginString$split$m3,
	        _marginString$split$m4 = _marginString$split$m2[1],
	        m1 = _marginString$split$m4 === undefined ? m0 : _marginString$split$m4,
	        _marginString$split$m5 = _marginString$split$m2[2],
	        m2 = _marginString$split$m5 === undefined ? m0 : _marginString$split$m5,
	        _marginString$split$m6 = _marginString$split$m2[3],
	        m3 = _marginString$split$m6 === undefined ? m1 : _marginString$split$m6;
	
	    return m0 + ' ' + m1 + ' ' + m2 + ' ' + m3;
	}
	
	function shallowCompare(next, prev) {
	    if (Array.isArray(next) && Array.isArray(prev)) {
	        if (next.length === prev.length) {
	            return next.some(function (_, index) {
	                return shallowCompare(next[index], prev[index]);
	            });
	        }
	    }
	
	    return next !== prev;
	}

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.countTypesTags = countTypesTags;
	exports.propsWithNoScriptRender = propsWithNoScriptRender;
	exports.wrapTypesToLazyChild = wrapTypesToLazyChild;
	exports.wrapTypesToNoScript = wrapTypesToNoScript;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(487);
	
	var _Lazy = __webpack_require__(289);
	
	var _Lazy2 = _interopRequireDefault(_Lazy);
	
	var _LazyChild = __webpack_require__(412);
	
	var _LazyChild2 = _interopRequireDefault(_LazyChild);
	
	var _LazyGroup = __webpack_require__(290);
	
	var _LazyGroup2 = _interopRequireDefault(_LazyGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function countTypesTags(types, children) {
	    var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	    if (!children) {
	        return count;
	    }
	
	    _react2.default.Children.forEach(children, function (child) {
	        if (!child || child.type === _Lazy2.default || child.type === _LazyGroup2.default || child.type === _LazyChild2.default) {
	            return;
	        } else if (types.includes(child.type)) {
	            count++;
	        } else {
	            var props = child.props || child._store && child._store.props || {};
	            count += countTypesTags(types, props.children);
	        }
	    });
	
	    return count;
	}
	
	function propsWithNoScriptRender(children, ltIE9) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var noscript = (0, _server.renderToStaticMarkup)(_react2.default.createElement('noscript', null, children));
	
	    var __html = !ltIE9 ? noscript : noscript.replace('<noscript>', '<!--[if IE 9]><!--><noscript><!--<![endif]-->').replace('</noscript>', '<!--[if IE 9]><!--></noscript><!--<![endif]-->');
	
	    props.dangerouslySetInnerHTML = { __html: __html };
	
	    return props;
	}
	
	function wrapTypesToLazyChild(types, children, wrapper, callback) {
	    if (!children) {
	        return children;
	    }
	
	    return _react2.default.Children.map(children, function (child) {
	        if (!child || child.type === _Lazy2.default || child.type === _LazyGroup2.default || child.type === _LazyChild2.default) {
	            return child;
	        } else if (types.includes(child.type)) {
	            return _react2.default.createElement(
	                _LazyChild2.default,
	                { callback: callback, wrapper: wrapper },
	                child
	            );
	        } else {
	            var props = child.props || child._store && child._store.props || {};
	            var _children = wrapTypesToLazyChild(types, props.children, wrapper, callback);
	
	            if (_children !== props.children) {
	                return _react2.default.cloneElement(child, null, _children);
	            } else {
	                return child;
	            }
	        }
	    });
	}
	
	function wrapTypesToNoScript(types, children, ltIE9, wrapper) {
	    if (!children) {
	        return children;
	    }
	
	    return _react2.default.Children.map(children, function (child) {
	        if (!child || child.type === _Lazy2.default || child.type === _LazyGroup2.default || child.type === _LazyChild2.default) {
	            return child;
	        } else if (types.includes(child.type)) {
	            return _react2.default.createElement(wrapper, propsWithNoScriptRender(child, ltIE9));
	        } else {
	            var props = child.props || child._store && child._store.props || {};
	            var _children2 = wrapTypesToNoScript(types, props.children, ltIE9, wrapper);
	
	            if (_children2 !== props.children) {
	                return _react2.default.cloneElement(child, null, _children2);
	            } else {
	                return child;
	            }
	        }
	    });
	}

/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hss_logo_black_final.2af6ff25.svg";

/***/ }),

/***/ 983:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SocialLinks = __webpack_require__(306);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	var _hss_logo_black_final = __webpack_require__(981);
	
	var _hss_logo_black_final2 = _interopRequireDefault(_hss_logo_black_final);
	
	var _neh = __webpack_require__(984);
	
	var _neh2 = _interopRequireDefault(_neh);
	
	var _mapPin = __webpack_require__(983);
	
	var _mapPin2 = _interopRequireDefault(_mapPin);
	
	var _AboutSidebarModule = __webpack_require__(826);
	
	var _AboutSidebarModule2 = _interopRequireDefault(_AboutSidebarModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutSidebar = function AboutSidebar(props) {
	  // console.log(props.settingsContent);
	  return _react2.default.createElement(
	    'div',
	    { className: _AboutSidebarModule2.default.aboutSidebar + ' ' + (props.show ? _AboutSidebarModule2.default.loaded : '') },
	    _react2.default.createElement(
	      'div',
	      { className: _AboutSidebarModule2.default.link },
	      _react2.default.createElement(
	        'a',
	        { href: props.settingsContent.credits_pdf_file[0].url, target: '_blank' },
	        props.settingsContent.credits_pdf_link_text
	      )
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Visit the Exhibition in Person'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _AboutSidebarModule2.default.address },
	      _react2.default.createElement(
	        'p',
	        null,
	        '265 Henry Street'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'New York, NY 10002'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _AboutSidebarModule2.default.hours },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Hours:'
	      ),
	      props.settingsContent.hours.map(function (data, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: 'day' + i },
	          _react2.default.createElement(
	            'p',
	            null,
	            data.days,
	            ' \u2022\xA0',
	            data.open_time,
	            '-',
	            data.close_time
	          )
	        );
	      }),
	      props.settingsContent.weekend_hours && _react2.default.createElement(
	        'div',
	        { className: _AboutSidebarModule2.default.weekend },
	        _react2.default.createElement(
	          'a',
	          {
	            href: props.settingsContent.weekend_hours.url,
	            target: props.settingsContent.weekend_hours.target
	          },
	          props.settingsContent.weekend_hours.title
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _AboutSidebarModule2.default.socialWrapper },
	      _react2.default.createElement(_SocialLinks2.default, { noPad: true, redIcons: true, data: props.settingsContent.social })
	    ),
	    _react2.default.createElement(
	      'a',
	      {
	        href: 'https://goo.gl/maps/Qau5zPdXRJ12',
	        target: '_blank',
	        className: _AboutSidebarModule2.default.directions
	      },
	      _react2.default.createElement('img', { src: _mapPin2.default, alt: 'Map Pin Icon', className: _AboutSidebarModule2.default.mapPin }),
	      _react2.default.createElement(
	        'div',
	        { className: _AboutSidebarModule2.default.directionsText },
	        'Get Directions'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('img', {
	        src: _neh2.default,
	        alt: 'National Endowment for the Humanities',
	        className: _AboutSidebarModule2.default.nehLogo
	      }),
	      _react2.default.createElement(
	        'p',
	        { className: _AboutSidebarModule2.default.greyText },
	        'The House on Henry Street is made possible, in part, by a major grant from the National Endowment for the Humanities: Exploring the human endeavor'
	      )
	    )
	  );
	};
	
	exports.default = AboutSidebar;
	module.exports = exports['default'];

/***/ }),

/***/ 826:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"aboutSidebar":"src-components-basic----AboutSidebar-module---aboutSidebar---3iXEd","loaded":"src-components-basic----AboutSidebar-module---loaded---3xs15","fadeInUp":"src-components-basic----AboutSidebar-module---fadeInUp---7eYGM","link":"src-components-basic----AboutSidebar-module---link---z7aaD","nehLogo":"src-components-basic----AboutSidebar-module---nehLogo---M99bp","greyText":"src-components-basic----AboutSidebar-module---greyText---2WoWK","address":"src-components-basic----AboutSidebar-module---address---v8NXb","hours":"src-components-basic----AboutSidebar-module---hours---Yu5sF","weekend":"src-components-basic----AboutSidebar-module---weekend---1kubc","socialWrapper":"src-components-basic----AboutSidebar-module---socialWrapper---tqNHO","directions":"src-components-basic----AboutSidebar-module---directions---1cymE","mapPin":"src-components-basic----AboutSidebar-module---mapPin---Racn6","directionsText":"src-components-basic----AboutSidebar-module---directionsText---Askp6","fadeIn":"src-components-basic----AboutSidebar-module---fadeIn---3A7aH","fadeInUpCenter":"src-components-basic----AboutSidebar-module---fadeInUpCenter---2MAbk","fadeInUpSmall":"src-components-basic----AboutSidebar-module---fadeInUpSmall---1i3k9","textCoverIn":"src-components-basic----AboutSidebar-module---textCoverIn---OGfA1","textCoverOut":"src-components-basic----AboutSidebar-module---textCoverOut---e8IOq"};

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EducatorResourceModule = __webpack_require__(827);
	
	var _EducatorResourceModule2 = _interopRequireDefault(_EducatorResourceModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EducatorResource = function EducatorResource(_ref) {
	  var title = _ref.title,
	      image = _ref.image,
	      body = _ref.body,
	      file = _ref.file;
	  return _react2.default.createElement(
	    'div',
	    { className: _EducatorResourceModule2.default.wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _EducatorResourceModule2.default.half + ' ' },
	      _react2.default.createElement(
	        'div',
	        { className: '' + _EducatorResourceModule2.default.image },
	        image && _react2.default.createElement('img', { src: image.url, alt: image.alt })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _EducatorResourceModule2.default.half + ' ' + _EducatorResourceModule2.default.content },
	      title && _react2.default.createElement(
	        'h4',
	        { className: _EducatorResourceModule2.default.title },
	        title
	      ),
	      body && _react2.default.createElement('div', {
	        className: _EducatorResourceModule2.default.body,
	        dangerouslySetInnerHTML: { __html: body }
	      }),
	      file && _react2.default.createElement(
	        'a',
	        { className: _EducatorResourceModule2.default.downloadLink, download: true, href: file.url },
	        'DOWNLOAD/' + file.size
	      )
	    )
	  );
	};
	
	exports.default = EducatorResource;
	module.exports = exports['default'];

/***/ }),

/***/ 827:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-basic----EducatorResource-module---wrapper---2H_ct","half":"src-components-basic----EducatorResource-module---half---3jdQ_","downloadLink":"src-components-basic----EducatorResource-module---downloadLink---18cdH","content":"src-components-basic----EducatorResource-module---content---23Rw0","title":"src-components-basic----EducatorResource-module---title---o6Y47","body":"src-components-basic----EducatorResource-module---body---1L1-w","fadeIn":"src-components-basic----EducatorResource-module---fadeIn---1a67P","fadeInUp":"src-components-basic----EducatorResource-module---fadeInUp---3J7B5","fadeInUpCenter":"src-components-basic----EducatorResource-module---fadeInUpCenter---2i-ct","fadeInUpSmall":"src-components-basic----EducatorResource-module---fadeInUpSmall---24uFm","textCoverIn":"src-components-basic----EducatorResource-module---textCoverIn---Rdb_n","textCoverOut":"src-components-basic----EducatorResource-module---textCoverOut---pVjny"};

/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/neh.1ca01006.svg";

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollIndicator = __webpack_require__(140);
	
	var _ScrollIndicator2 = _interopRequireDefault(_ScrollIndicator);
	
	var _RectButton = __webpack_require__(78);
	
	var _RectButton2 = _interopRequireDefault(_RectButton);
	
	var _IntroWithButtonModule = __webpack_require__(88);
	
	var _IntroWithButtonModule2 = _interopRequireDefault(_IntroWithButtonModule);
	
	var _gsap = __webpack_require__(11);
	
	var _CSSPlugin = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var plugins = [_CSSPlugin.CSSPlugin];
	var SplitText = void 0;
	
	var IntroWithButton = function (_Component) {
	  _inherits(IntroWithButton, _Component);
	
	  function IntroWithButton() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IntroWithButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.splitTextRun = false, _this.setThemeClass = function (color) {
	      switch (color) {
	        case 'blue':
	          return 'chapter-theme--blue';
	        case 'yellow':
	          return 'chapter-theme--yellow';
	        case 'green':
	          return 'chapter-theme--green';
	        default:
	          return 'chapter-theme--red';
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IntroWithButton.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window !== 'undefined') {
	      SplitText = __webpack_require__(144);
	    }
	    if (this.props.startHidden && this.props.show) {
	      _gsap.TweenLite.set(this.wrapper, { opacity: 1 });
	    }
	
	    this.runSplitText();
	
	    var header = this.wrapper.querySelectorAll('.maskDownTitle');
	    var subHeader = this.wrapper.querySelector('p');
	    var button = this.wrapper.querySelector('.js-introButton');
	    var kicker = this.wrapper.querySelector('h5');
	    var rule = this.wrapper.querySelector('.ch-inner-rule');
	    if (this.props.startHidden && !this.props.show) {
	      // console.log('transitioning, so hide slider text');
	      header && _gsap.TweenLite.set(header, { y: '100%' });
	      subHeader && _gsap.TweenLite.set(subHeader, { y: '10%', autoAlpha: 0 });
	      button && _gsap.TweenLite.set(button, { y: '100%' });
	      kicker && _gsap.TweenLite.set(kicker, { y: '100%' });
	      rule && _gsap.TweenLite.set(rule, { scaleX: 0 });
	      this.scrollIndicator && _gsap.TweenLite.set(this.scrollIndicator, { opacity: 0, y: 20 });
	    }
	  };
	
	  IntroWithButton.prototype.runSplitText = function runSplitText() {
	    // console.log(this.props.title, 'try to run splittext');
	    if (!this.props.doSplitText || this.splitTextRun) {
	      // console.log(this.props.title, 'already run, dont');
	      return;
	    }
	    // console.log(this.props.title, 'actually run it');
	    this.splitTextRun = true;
	
	    var splitWords = void 0;
	    var splitTarget = this.wrapper.querySelector('h1');
	    var splitText = new SplitText(splitTarget, {
	      type: 'words',
	      wordsClass: 'maskDownTitle'
	    });
	
	    if (typeof document !== 'undefined') {
	      splitWords = splitTarget.querySelectorAll('.maskDownTitle');
	    }
	    var wrap = function wrap(el, wrapper) {
	      el.parentNode.insertBefore(wrapper, el);
	      wrapper.appendChild(el);
	    };
	
	    splitWords.forEach(function (word) {
	      var element = void 0;
	      if (typeof document !== 'undefined') {
	        element = document.createElement('div');
	      }
	      element.className = _IntroWithButtonModule2.default.maskDownWrapper;
	      wrap(word, element);
	    });
	  };
	
	  IntroWithButton.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    // if text Changes, have to run split text again
	    if (this.props.title !== prevProps.title || this.props.subtitle !== prevProps.subtitle) {
	      // console.log('text change hide text and run split text');
	      this.splitTextRun = false;
	      this.runSplitText();
	      var header = this.wrapper.querySelectorAll('.maskDownTitle');
	      var subHeader = this.wrapper.querySelector('p');
	      var button = this.wrapper.querySelector('.js-introButton');
	      var kicker = this.wrapper.querySelector('h5');
	      var rule = this.wrapper.querySelector('.ch-inner-rule');
	      // if (this.props.textTransitioning ) {
	      // console.log('transitioning, so hide slider text');
	      _gsap.TweenLite.set(header, { y: '100%' });
	      _gsap.TweenLite.set(subHeader, { y: '10%', autoAlpha: 0 });
	      _gsap.TweenLite.set(button, { y: '100%' });
	      _gsap.TweenLite.set(kicker, { y: '100%' });
	      _gsap.TweenLite.set(rule, { scaleX: 0 });
	      // }
	
	      _gsap.TweenLite.set(this.wrapper, { opacity: 1 });
	    }
	  };
	
	  IntroWithButton.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    // FPO enter and exit animations for this element
	
	    if (this.props.startHidden && !this.props.show && nextProps.show) {
	      // run split text before show
	      this.runSplitText();
	      // show
	      // TweenLite.to(this.wrapper, 0.5, { opacity: 1 });
	
	      // console.log('reveal text on change of show prop, nextProps.show true');
	      var header = this.wrapper.querySelectorAll('.maskDownTitle');
	      var subHeader = this.wrapper.querySelector('p');
	      var button = this.wrapper.querySelector('.js-introButton');
	      var kicker = this.wrapper.querySelector('h5');
	      var rule = this.wrapper.querySelector('.ch-inner-rule');
	
	      _gsap.TweenLite.set(this.wrapper, { opacity: 1 });
	
	      var duration = 0.78;
	      var increment = 0.2;
	      var delay = 0.0;
	
	      var tl = new _gsap.TimelineLite();
	      if (kicker) {
	        tl.to(kicker, duration, {
	          y: '0%',
	          ease: Quad.easeInOut
	        }, delay += increment);
	      }
	
	      rule && tl.to(rule, duration, {
	        scaleX: 1,
	        ease: Quad.easeInOut
	      }, delay += increment);
	
	      header && tl.to(header, duration, {
	        y: '0%',
	        ease: Quad.easeInOut
	      }, delay += increment);
	
	      subHeader && tl.to(subHeader, duration, {
	        y: '0%',
	        autoAlpha: 1,
	        ease: Quad.easeInOut
	      }, delay += increment);
	
	      button && tl.to(button, duration, {
	        y: '0%',
	        ease: Quad.easeOut
	      }, delay);
	      this.scrollIndicator && _gsap.TweenLite.to(this.scrollIndicator, duration, {
	        opacity: 1,
	        y: 0,
	        delay: 0.5
	      });
	    }
	    if (this.props.startHidden && this.props.show && !nextProps.show) {
	      // hide
	      // console.log('hide text when next props show is false');
	      var _header = this.wrapper.querySelectorAll('.maskDownTitle');
	      var _subHeader = this.wrapper.querySelector('p');
	      var _button = this.wrapper.querySelector('.js-introButton');
	      var _kicker = this.wrapper.querySelector('h5');
	      var _rule = this.wrapper.querySelector('.ch-inner-rule');
	
	      var _duration = 0.6;
	      var _increment = 0.0;
	      var _delay = 0.0;
	
	      {
	        _kicker && _gsap.TweenLite.to(_kicker, _duration, {
	          y: '100%',
	          ease: Quad.easeIn,
	          delay: _delay,
	          onComplete: function onComplete() {
	            _gsap.TweenLite.set(_this2.wrapper, { opacity: 0 });
	          }
	        });
	        _delay += _increment;
	      }
	
	      _rule && _gsap.TweenLite.to(_rule, _duration * 0.5, {
	        scaleX: 0,
	        ease: Quad.easeOut,
	        delay: _delay
	      });
	      _delay += _increment;
	      _header && _gsap.TweenLite.to(_header, _duration, {
	        y: '100%',
	        ease: Quad.easeOut,
	        delay: _delay
	      });
	      _delay += _increment;
	      _subHeader && _gsap.TweenLite.to(_subHeader, _duration, {
	        y: '10%',
	        autoAlpha: 0,
	        ease: Quad.easeOut,
	        delay: _delay
	      });
	      _delay += _increment;
	      _button && _gsap.TweenLite.to(_button, _duration, {
	        y: '100%',
	        ease: Quad.easeOut,
	        delay: _delay
	      });
	
	      this.scrollIndicator && _gsap.TweenLite.to(this.scrollIndicator, _duration, {
	        opacity: 0,
	        y: 20,
	        delay: 0.5
	      });
	    }
	
	    // text back on after chapter transition
	    if (this.props.textExit && !nextProps.textExit) {
	      // console.log('set text back on false textExit prop');
	      var resetElements = [this.wrapper.querySelector('h1'), this.wrapper.querySelector('p'), this.wrapper.querySelector('.js-introButton'), this.wrapper.querySelector('h5')];
	      resetElements.forEach(function (el) {
	        if (el) {
	          el.removeAttribute('style');
	        }
	      });
	    }
	    // text animate off for chapter click
	    if (!this.props.textExit && nextProps.textExit) {
	      // console.log('textExit so hide');
	      // chapter exit text animation
	      var _header2 = this.wrapper.querySelector('h1');
	      var _subHeader2 = this.wrapper.querySelector('p');
	      var _button2 = this.wrapper.querySelector('.js-introButton');
	      var _kicker2 = this.wrapper.querySelector('h5');
	
	      var _tl = new _gsap.TimelineLite();
	      if (_kicker2) {
	        _gsap.TweenLite.to(_kicker2, 0.8, {
	          css: {
	            color: '#FFFFFF'
	          },
	          ease: Circ.easeInOut
	        });
	      }
	
	      _tl.to(_subHeader2, 0.8, {
	        opacity: 0,
	        ease: Circ.easeInOut
	      }).to(_button2, 0.8, {
	        opacity: 0,
	        ease: Circ.easeInOut
	      }, '-=' + 0.8).to(_header2, 0.8, {
	        css: {
	          color: '#FFFFFF'
	        },
	        ease: Circ.easeInOut
	      }, '-=' + 0.8);
	    }
	  };
	
	  IntroWithButton.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        path = _props.path,
	        kicker = _props.kicker,
	        buttonText = _props.buttonText,
	        subtitle = _props.subtitle,
	        colorTheme = _props.colorTheme,
	        scrollIndicator = _props.scrollIndicator,
	        handleClick = _props.handleClick,
	        textWhite = _props.textWhite,
	        noPad = _props.noPad,
	        scrollClass = _props.scrollClass,
	        scrollOffset = _props.scrollOffset,
	        buttonCTA = _props.buttonCTA,
	        index = _props.index,
	        startHidden = _props.startHidden,
	        noMobileRule = _props.noMobileRule,
	        noButton = _props.noButton;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        ref: function ref(el) {
	          _this3.wrapper = el;
	        }
	        // chapter-info
	        , className: 'intro-text ' + _IntroWithButtonModule2.default.infoWrapper + ' ' + this.setThemeClass(colorTheme) + ' ' + (textWhite ? _IntroWithButtonModule2.default.textWhite : '') + ' ' + (noPad ? _IntroWithButtonModule2.default.noPad : '') + ' ' + (startHidden ? _IntroWithButtonModule2.default.startHidden : '') + ' ' + (noMobileRule ? _IntroWithButtonModule2.default.noMobileRule : '')
	      },
	      kicker && _react2.default.createElement(
	        'div',
	        { className: _IntroWithButtonModule2.default.maskWrap },
	        _react2.default.createElement(
	          'h5',
	          null,
	          kicker
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: '' + _IntroWithButtonModule2.default.innerWrap },
	        _react2.default.createElement(
	          'div',
	          { className: _IntroWithButtonModule2.default.maskWrap + ' ' + _IntroWithButtonModule2.default.ruleMask },
	          _react2.default.createElement('span', {
	            style: { transformOrigin: '0 50%' },
	            className: 'ch-inner-rule ' + _IntroWithButtonModule2.default.innerRule
	          })
	        ),
	        title && _react2.default.createElement(
	          'div',
	          { className: _IntroWithButtonModule2.default.titleWrapper },
	          _react2.default.createElement('h1', {
	            className: 'splitText-' + index,
	            dangerouslySetInnerHTML: { __html: title }
	          })
	        ),
	        subtitle && _react2.default.createElement(
	          'div',
	          { className: _IntroWithButtonModule2.default.maskWrap + ' ' + _IntroWithButtonModule2.default.subtitleWrap },
	          _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: subtitle } })
	        ),
	        path && !noButton && _react2.default.createElement(
	          'div',
	          { className: _IntroWithButtonModule2.default.maskWrap },
	          _react2.default.createElement(
	            'div',
	            { className: 'js-introButton' },
	            _react2.default.createElement(_RectButton2.default, {
	              path: path,
	              buttonText: buttonText ? buttonText : 'Explore',
	              handleClick: handleClick
	            })
	          )
	        ),
	        scrollIndicator && _react2.default.createElement(
	          'div',
	          {
	            ref: function ref(el) {
	              _this3.scrollIndicator = el;
	            }
	          },
	          _react2.default.createElement(_ScrollIndicator2.default, {
	            scrollClass: scrollClass,
	            scrollOffset: scrollOffset
	          })
	        )
	      )
	    );
	  };
	
	  return IntroWithButton;
	}(_react.Component);
	
	exports.default = IntroWithButton;
	module.exports = exports['default'];

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"innerRule":"src-components-global----IntroWithButton-module---innerRule---2uz3M","ruleMask":"src-components-global----IntroWithButton-module---ruleMask---I10EJ","noMobileRule":"src-components-global----IntroWithButton-module---noMobileRule---1FH7b","infoWrapper":"src-components-global----IntroWithButton-module---infoWrapper---28Q5L","noPad":"src-components-global----IntroWithButton-module---noPad---uRpVp","textWhite":"src-components-global----IntroWithButton-module---textWhite---1n0fg","startHidden":"src-components-global----IntroWithButton-module---startHidden---3Ik6w","maskDownWrapper":"src-components-global----IntroWithButton-module---maskDownWrapper---1CE5R","subtitleWrap":"src-components-global----IntroWithButton-module---subtitleWrap---3V1MX","maskWrap":"src-components-global----IntroWithButton-module---maskWrap---3ssr6","fadeIn":"src-components-global----IntroWithButton-module---fadeIn---En3ul","fadeInUp":"src-components-global----IntroWithButton-module---fadeInUp---2543W","fadeInUpCenter":"src-components-global----IntroWithButton-module---fadeInUpCenter---1wd9t","fadeInUpSmall":"src-components-global----IntroWithButton-module---fadeInUpSmall---uMzc-","textCoverIn":"src-components-global----IntroWithButton-module---textCoverIn---2WfKk","textCoverOut":"src-components-global----IntroWithButton-module---textCoverOut---38T8k"};

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SocialLinksModule = __webpack_require__(398);
	
	var _SocialLinksModule2 = _interopRequireDefault(_SocialLinksModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialLinks = function SocialLinks(props) {
	  return _react2.default.createElement(
	    'ul',
	    {
	      className: _SocialLinksModule2.default.socialLinks + ' ' + (props.mainNavColor === 'white' ? _SocialLinksModule2.default.whiteSocial : '') + ' ' + (props.redIcons ? _SocialLinksModule2.default.redSocial : '') + ' '
	    },
	    _react2.default.createElement(
	      'li',
	      { className: (props.noPad ? _SocialLinksModule2.default.noPad : '') + ' ' + _SocialLinksModule2.default.socialItem },
	      _react2.default.createElement(
	        'a',
	        {
	          href: props.data.instagram,
	          className: _SocialLinksModule2.default.instagram,
	          target: '_blank',
	          rel: 'noopener'
	        },
	        _react2.default.createElement(
	          'svg',
	          {
	            xmlns: 'http://www.w3.org/2000/svg',
	            width: '26',
	            height: '26',
	            viewBox: '0 0 26 26'
	          },
	          _react2.default.createElement(
	            'title',
	            null,
	            'Instagram Icon'
	          ),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            d: 'M13.021,18.044 C15.79,18.044 18.043,15.791 18.043,13.022 C18.043,10.253 15.79,8 13.021,8 C10.252,8 8,10.253 8,13.022 C8,15.791 10.252,18.044 13.021,18.044 Z M13.021,6 C16.893,6 20.043,9.15 20.043,13.022 C20.043,16.894 16.893,20.044 13.021,20.044 C9.149,20.044 6,16.894 6,13.022 C6,9.15 9.149,6 13.021,6 Z M19.5,0 C23.084,0 26,2.916 26,6.5 L26,19.5 C26,23.084 23.084,26 19.5,26 L6.5,26 C2.916,26 0,23.084 0,19.5 L0,6.5 C0,2.916 2.916,0 6.5,0 L19.5,0 Z M24,19.5 L24,6.5 C24,4.019 21.981,2 19.5,2 L6.5,2 C4.019,2 2,4.019 2,6.5 L2,19.5 C2,21.981 4.019,24 6.5,24 L19.5,24 C21.981,24 24,21.981 24,19.5 Z M20,5 C19.4477153,5 19,4.55228475 19,4 C19,3.44771525 19.4477153,3 20,3 C20.5522847,3 21,3.44771525 21,4 C21,4.55228475 20.5522847,5 20,5 Z'
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      { className: _SocialLinksModule2.default.socialItem },
	      _react2.default.createElement(
	        'a',
	        {
	          href: props.data.facebook,
	          className: _SocialLinksModule2.default.facebook,
	          target: '_blank',
	          rel: 'noopener'
	        },
	        _react2.default.createElement(
	          'svg',
	          {
	            xmlns: 'http://www.w3.org/2000/svg',
	            width: '22',
	            height: '22',
	            viewBox: '0 0 22 22'
	          },
	          _react2.default.createElement(
	            'title',
	            null,
	            'Facebook Icon'
	          ),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            d: 'M20.3076923,0 L1.69230769,0 C0.759,0 0,0.759 0,1.69230769 L0,20.3076923 C0,21.241 0.759,22 1.69230769,22 L10.5769231,22 C10.8104615,22 11,21.8104615 11,21.5769231 L11,15.6538462 C11,15.4203077 10.8104615,15.2307692 10.5769231,15.2307692 L8.88461538,15.2307692 C8.65107692,15.2307692 8.46153846,15.0412308 8.46153846,14.8076923 L8.46153846,11.4230769 C8.46153846,11.1895385 8.65107692,11 8.88461538,11 L10.5769231,11 C10.8104615,11 11,10.8104615 11,10.5769231 L11,8.88461538 C11,6.31823077 13.0874615,4.23076923 15.6538462,4.23076923 L18.1923077,4.23076923 C18.4258462,4.23076923 18.6153846,4.42030769 18.6153846,4.65384615 L18.6153846,8.03846154 C18.6153846,8.272 18.4258462,8.46153846 18.1923077,8.46153846 L16.5,8.46153846 C15.8002308,8.46153846 15.2307692,9.031 15.2307692,9.73076923 L15.2307692,10.5769231 C15.2307692,10.8104615 15.4203077,11 15.6538462,11 L18.1923077,11 C18.3141538,11 18.4292308,11.0524615 18.5096154,11.143 C18.59,11.2343846 18.6272308,11.3553846 18.612,11.4755385 L18.1889231,14.8601538 C18.1626923,15.0716923 17.9816154,15.2307692 17.7692308,15.2307692 L15.6538462,15.2307692 C15.4203077,15.2307692 15.2307692,15.4203077 15.2307692,15.6538462 L15.2307692,21.5769231 C15.2307692,21.8104615 15.4203077,22 15.6538462,22 L20.3076923,22 C21.241,22 22,21.241 22,20.3076923 L22,1.69230769 C22,0.759 21.241,0 20.3076923,0'
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      { className: _SocialLinksModule2.default.socialItem },
	      _react2.default.createElement(
	        'a',
	        {
	          href: props.data.twitter,
	          className: _SocialLinksModule2.default.twitter,
	          target: '_blank',
	          rel: 'noopener'
	        },
	        _react2.default.createElement(
	          'svg',
	          {
	            xmlns: 'http://www.w3.org/2000/svg',
	            width: '22',
	            height: '18',
	            viewBox: '0 0 22 18'
	          },
	          _react2.default.createElement(
	            'title',
	            null,
	            'Twitter Icon'
	          ),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            d: 'M21.9063255,2.13692846 C21.7963258,2.01372874 21.6159262,1.98072881 21.4685265,2.05406198 C21.2961936,2.14059512 20.9148611,2.2630615 20.4975954,2.36939459 C20.9207278,1.8831957 21.2741936,1.29506371 21.4149933,0.775864896 C21.4553265,0.626998569 21.39886,0.470065594 21.2741936,0.380599131 C21.1480606,0.291132669 20.9808609,0.290399337 20.8547279,0.376932473 C20.5723952,0.569065368 19.2457982,1.13299741 18.4230001,1.29653037 C17.4014691,0.401132418 16.3887381,0 15.1611409,0 C14.252543,0 13.4084782,0.250066096 12.4250805,0.810331484 C10.6724178,1.8091292 10.4069517,4.00692419 10.5580181,5.29538792 C5.71216246,4.89132217 2.99663532,2.191195 2.03743751,1.021531 C1.96190435,0.929864545 1.84603795,0.877797997 1.72797155,0.88806464 C1.60917182,0.89686462 1.5021054,0.961397806 1.44050554,1.06333091 C0.801040331,2.11492851 0.624307401,3.29485915 0.930840035,4.47478979 C1.12297293,5.21472143 1.48230544,5.86591995 1.88710452,6.37485212 C1.59303852,6.2215858 1.30410585,6.02651958 1.05697308,5.8299867 C0.946973331,5.7419869 0.795907009,5.72658693 0.669773964,5.78672013 C0.542907587,5.84831999 0.462241104,5.9759197 0.462241104,6.11671938 C0.462241104,8.25071451 1.90103782,9.70711118 3.14110166,10.4265095 C2.86756895,10.378843 2.58303626,10.3018432 2.32123686,10.22411 C2.18263718,10.1830434 2.03303752,10.22631 1.93917107,10.3355764 C1.84457128,10.4441095 1.82330466,10.5988425 1.88343786,10.7293755 C2.64316946,12.3676384 4.17876596,13.573969 5.87789541,13.9362349 C4.40976543,14.8528994 2.32710352,15.3104984 0.407974561,15.0926989 C0.236374953,15.0758323 0.0706419976,15.1799654 0.0171087864,15.347165 C-0.0356910931,15.5136313 0.0369087412,15.6947642 0.19090839,15.7790973 C2.42536996,17.0044945 4.74636466,17.5999598 7.2858922,17.5999598 L7.3020255,17.5999598 C10.8792173,17.5970265 14.2085431,16.0672967 16.6754708,13.2938363 C18.9121323,10.7799754 20.076663,7.59291601 19.8192636,4.72338922 C20.4235289,4.2965902 21.3651267,3.47012541 21.9407921,2.58132744 C22.0309919,2.44272776 22.0170586,2.26012818 21.9063255,2.13692846'
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      { className: _SocialLinksModule2.default.socialItem },
	      _react2.default.createElement(
	        'a',
	        {
	          href: props.data.youtube,
	          className: _SocialLinksModule2.default.youtube,
	          target: '_blank',
	          rel: 'noopener'
	        },
	        _react2.default.createElement(
	          'svg',
	          {
	            xmlns: 'http://www.w3.org/2000/svg',
	            width: '26',
	            height: '19',
	            viewBox: '0 0 26 19'
	          },
	          _react2.default.createElement(
	            'title',
	            null,
	            'YouTube Icon'
	          ),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            d: 'M17.9299545,9.86877273 L10.1572273,14.6187727 C10.0881364,14.6610909 10.0104091,14.6818182 9.93181818,14.6818182 C9.85927273,14.6818182 9.78672727,14.6636818 9.72109091,14.6265455 C9.58463636,14.5505455 9.5,14.4063182 9.5,14.25 L9.5,4.75 C9.5,4.59454545 9.58463636,4.45031818 9.72109091,4.37345455 C9.85754545,4.29745455 10.0242273,4.30004545 10.1572273,4.38122727 L17.9299545,9.13122727 C18.0577727,9.20981818 18.1363636,9.34972727 18.1363636,9.5 C18.1363636,9.65113636 18.0577727,9.79018182 17.9299545,9.86877273 M22.3448636,0.589 C21.6902273,0.534590909 21.0545909,0.475863636 20.4241364,0.418 C18.0992273,0.202954545 15.9038636,0 12.9545455,0 C10.1054091,0 7.71572727,0.216772727 5.4055,0.426636364 C4.79577273,0.481909091 4.18518182,0.537181818 3.56422727,0.589 C1.56577273,0.756545455 0,2.45704545 0,4.46240909 L0,14.5384545 C0,16.5429545 1.56577273,18.2443182 3.56422727,18.411 C4.21368182,18.4654091 4.84413636,18.5232727 5.47113636,18.5811364 C7.81331818,18.7961818 10.0259545,19 12.9545455,19 C15.9660455,19 18.1113182,18.7996364 20.3844091,18.5880455 C21.0243636,18.5275909 21.6720909,18.468 22.3448636,18.411 C24.3441818,18.2443182 25.9090909,16.5429545 25.9090909,14.5384545 L25.9090909,4.46240909 C25.9090909,2.45704545 24.3441818,0.756545455 22.3448636,0.589'
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = SocialLinks;
	module.exports = exports['default'];

/***/ }),

/***/ 398:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"socialLinks":"src-components-global----SocialLinks-module---socialLinks---17CCv","socialItem":"src-components-global----SocialLinks-module---socialItem---12Bzo","noPad":"src-components-global----SocialLinks-module---noPad---3fAl3","whiteSocial":"src-components-global----SocialLinks-module---whiteSocial---2EuQq","redSocial":"src-components-global----SocialLinks-module---redSocial---2nZSj","facebook":"src-components-global----SocialLinks-module---facebook---2B4U1","twitter":"src-components-global----SocialLinks-module---twitter---3sSPt","fadeIn":"src-components-global----SocialLinks-module---fadeIn---2S5Op","fadeInUp":"src-components-global----SocialLinks-module---fadeInUp---1O4yc","fadeInUpCenter":"src-components-global----SocialLinks-module---fadeInUpCenter---1jL1L","fadeInUpSmall":"src-components-global----SocialLinks-module---fadeInUpSmall---2VQHI","textCoverIn":"src-components-global----SocialLinks-module---textCoverIn---1mAPi","textCoverOut":"src-components-global----SocialLinks-module---textCoverOut----uHUq"};

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RectButtonModule = __webpack_require__(158);
	
	var _RectButtonModule2 = _interopRequireDefault(_RectButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// if path is passed, renders a link (which can also take a click handler)
	// If no path, it renders a button
	var RectButton = function RectButton(_ref) {
	  var path = _ref.path,
	      buttonText = _ref.buttonText,
	      externalLink = _ref.externalLink,
	      handleClick = _ref.handleClick;
	  return path ? _react2.default.createElement(
	    'a',
	    {
	      href: path,
	      className: 'chapter-button ' + _RectButtonModule2.default.rectButton,
	      target: externalLink ? '_blank' : '',
	      rel: externalLink ? 'noopener' : '',
	      onClick: handleClick ? handleClick : function () {}
	    },
	    buttonText
	  ) : _react2.default.createElement(
	    'button',
	    {
	      className: 'chapter-button ' + _RectButtonModule2.default.rectButton,
	      onClick: handleClick
	    },
	    buttonText
	  );
	};
	
	exports.default = RectButton;
	module.exports = exports['default'];

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"rectButton":"src-components-ui----RectButton-module---rectButton---kOGDP","fadeIn":"src-components-ui----RectButton-module---fadeIn---2i_MH","fadeInUp":"src-components-ui----RectButton-module---fadeInUp---1Klsv","fadeInUpCenter":"src-components-ui----RectButton-module---fadeInUpCenter---24B-G","fadeInUpSmall":"src-components-ui----RectButton-module---fadeInUpSmall---2LhD0","textCoverIn":"src-components-ui----RectButton-module---textCoverIn---1AHwq","textCoverOut":"src-components-ui----RectButton-module---textCoverOut---2lqeu"};

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jump = __webpack_require__(81);
	
	var _jump2 = _interopRequireDefault(_jump);
	
	var _ArrowButton = __webpack_require__(49);
	
	var _ArrowButton2 = _interopRequireDefault(_ArrowButton);
	
	var _ScrollIndicatorModule = __webpack_require__(159);
	
	var _ScrollIndicatorModule2 = _interopRequireDefault(_ScrollIndicatorModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Smooth scroll to content start
	var scrollClick = function scrollClick(scrollClass, scrollOffset) {
	  (0, _jump2.default)(scrollClass, {
	    offset: scrollOffset
	  });
	};
	
	var ScrollIndicator = function ScrollIndicator(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      className: _ScrollIndicatorModule2.default.scrollIndicator,
	      onClick: function onClick() {
	        scrollClick(props.scrollClass, props.scrollOffset);
	      }
	    },
	    _react2.default.createElement(_ArrowButton2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: _ScrollIndicatorModule2.default.scrollText },
	      'Scroll'
	    )
	  );
	};
	
	exports.default = ScrollIndicator;
	module.exports = exports['default'];

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"scrollIndicator":"src-components-ui----ScrollIndicator-module---scrollIndicator---3-hD6","scrollText":"src-components-ui----ScrollIndicator-module---scrollText---7KuIx","fadeIn":"src-components-ui----ScrollIndicator-module---fadeIn---2RGcS","fadeInUp":"src-components-ui----ScrollIndicator-module---fadeInUp---XKTTZ","fadeInUpCenter":"src-components-ui----ScrollIndicator-module---fadeInUpCenter---2JaVr","fadeInUpSmall":"src-components-ui----ScrollIndicator-module---fadeInUpSmall---10Khg","textCoverIn":"src-components-ui----ScrollIndicator-module---textCoverIn---MwX7O","textCoverOut":"src-components-ui----ScrollIndicator-module---textCoverOut---1_0em"};

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.exhibitionQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AboutSidebar = __webpack_require__(501);
	
	var _AboutSidebar2 = _interopRequireDefault(_AboutSidebar);
	
	var _EducatorResource = __webpack_require__(502);
	
	var _EducatorResource2 = _interopRequireDefault(_EducatorResource);
	
	var _IntroWithButton = __webpack_require__(82);
	
	var _IntroWithButton2 = _interopRequireDefault(_IntroWithButton);
	
	var _RectButton = __webpack_require__(78);
	
	var _RectButton2 = _interopRequireDefault(_RectButton);
	
	var _IntroWithButtonModule = __webpack_require__(88);
	
	var _IntroWithButtonModule2 = _interopRequireDefault(_IntroWithButtonModule);
	
	var _basicModule = __webpack_require__(871);
	
	var _basicModule2 = _interopRequireDefault(_basicModule);
	
	var _reactLazy = __webpack_require__(291);
	
	var _reactIntersectionObserver = __webpack_require__(180);
	
	var _reactIntersectionObserver2 = _interopRequireDefault(_reactIntersectionObserver);
	
	var _reactHelmet = __webpack_require__(179);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BasicPage = function (_Component) {
	  _inherits(BasicPage, _Component);
	
	  function BasicPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BasicPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      topImageLoaded: false,
	      bottomImageLoaded: false,
	      revealText: false,
	      topImageInView: false,
	      bottomImageInView: false
	    }, _this.title = _this.props.data.dataJson.title.replace('<strong>', '').replace('</strong>', ''), _this.handleTopImageLoaded = function () {
	      _this.setState({
	        topImageLoaded: true
	      }, _this.handleTopImageInView);
	    }, _this.handleBottomImageLoaded = function () {
	      _this.setState({
	        bottomImageLoaded: true
	      }, _this.handleBottomImageInView);
	    }, _this.handleTopImageInView = function () {
	      _this.state.topImageLoaded && _this.setState({
	        topImageInView: true
	      });
	    }, _this.handleBottomImageInView = function () {
	      _this.state.bottomImageLoaded && _this.setState({
	        bottomImageInView: true
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BasicPage.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      _this2.setState({ revealText: true });
	    }, 300);
	    this.props.resetDisplaySettings();
	    this.props.setHeaderTransparent(false);
	    // this.props.setHeaderSticky(true);
	    // this.props.setHeaderStatic(false);
	    this.props.setThemeColor('red');
	  };
	
	  BasicPage.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.props.setHeaderTransparent(true);
	    // this.props.setHeaderSticky(false);
	    // this.props.setHeaderStatic(true);
	  };
	
	  BasicPage.prototype.isPage = function isPage(pageString) {
	    return this.props.location.pathname.indexOf(pageString) !== -1;
	  };
	
	  BasicPage.prototype.render = function render() {
	    var _props$data$dataJson = this.props.data.dataJson,
	        title = _props$data$dataJson.title,
	        color_theme = _props$data$dataJson.color_theme,
	        subtitle = _props$data$dataJson.subtitle,
	        body = _props$data$dataJson.body,
	        second_body = _props$data$dataJson.second_body,
	        headline = _props$data$dataJson.headline,
	        second_headline = _props$data$dataJson.second_headline,
	        top_image = _props$data$dataJson.top_image,
	        bottom_image = _props$data$dataJson.bottom_image,
	        page_content = _props$data$dataJson.page_content,
	        is_about_page = _props$data$dataJson.is_about_page,
	        second_cta = _props$data$dataJson.second_cta;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: _basicModule2.default.basicPage + ' ' + (this.props.transition && this.props.transition.status === 'exiting' ? _basicModule2.default.exiting : '')
	      },
	      _react2.default.createElement(_reactHelmet2.default, { title: this.title + ' | The House on Henry Street' }),
	      _react2.default.createElement(
	        'div',
	        { className: _basicModule2.default.topWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _basicModule2.default.introWrapper },
	          _react2.default.createElement(
	            'div',
	            {
	              className: _basicModule2.default.textEnter + ' ' + (!this.props.introIsShowing && this.state.revealText ? _basicModule2.default.textEnterShow : '')
	            },
	            _react2.default.createElement(
	              'div',
	              { className: _IntroWithButtonModule2.default.maskWrap + ' ' + _IntroWithButtonModule2.default.ruleMask },
	              _react2.default.createElement('span', {
	                style: { transformOrigin: '0 50%' },
	                className: 'ch-inner-rule ' + _IntroWithButtonModule2.default.innerRule
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _IntroWithButtonModule2.default.titleWrapper },
	              _react2.default.createElement('h1', {
	                style: {
	                  borderTop: '5px solid #D6434F',
	                  paddingTop: '20px',
	                  marginBottom: '10px'
	                },
	                dangerouslySetInnerHTML: {
	                  __html: !is_about_page ? title : headline
	                }
	              })
	            ),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: body } })
	          ),
	          is_about_page && _react2.default.createElement(_AboutSidebar2.default, {
	            settingsContent: this.props.settingsContent,
	            show: this.state.revealText && !this.props.introIsShowing
	          })
	        ),
	        top_image && _react2.default.createElement(
	          _reactLazy.Lazy,
	          {
	            onLoad: this.handleTopImageLoaded,
	            onViewport: this.handleTopImageInView,
	            className: _basicModule2.default.imageTop + ' ' + (this.state.topImageLoaded && this.state.topImageInView && !this.props.introIsShowing ? _basicModule2.default.loaded : '')
	          },
	          _react2.default.createElement('img', { src: top_image.url, alt: top_image.alt })
	        )
	      ),
	      is_about_page && _react2.default.createElement(
	        'div',
	        { className: _basicModule2.default.bottomWrapper },
	        _react2.default.createElement(
	          _reactLazy.Lazy,
	          {
	            onLoad: this.handleBottomImageLoaded,
	            onViewport: this.handleBottomImageInView,
	            className: _basicModule2.default.imageBottom + ' ' + (this.state.bottomImageLoaded && this.state.bottomImageInView && !this.props.introIsShowing ? _basicModule2.default.loaded : '')
	          },
	          _react2.default.createElement('img', { src: bottom_image.url, alt: bottom_image.alt })
	        ),
	        _react2.default.createElement(
	          _reactIntersectionObserver2.default,
	          {
	            onChange: this.handleBottomInview,
	            className: _basicModule2.default.introWrapperBottom,
	            triggerOnce: true
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: _basicModule2.default.textEnter + ' ' + (!this.props.introIsShowing && this.state.revealText ? _basicModule2.default.textEnterShow : '')
	            },
	            _react2.default.createElement(
	              'div',
	              {
	                className: _IntroWithButtonModule2.default.maskWrap + ' ' + _IntroWithButtonModule2.default.ruleMask
	              },
	              _react2.default.createElement('span', {
	                style: { transformOrigin: '0 50%' },
	                className: 'ch-inner-rule ' + _IntroWithButtonModule2.default.innerRule
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _IntroWithButtonModule2.default.titleWrapper },
	              _react2.default.createElement('h1', {
	                style: {
	                  borderTop: '5px solid #D6434F',
	                  paddingTop: '20px',
	                  marginBottom: '10px'
	                },
	                dangerouslySetInnerHTML: {
	                  __html: second_headline
	                }
	              })
	            ),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: second_body } })
	          ),
	          second_cta.url && _react2.default.createElement(_RectButton2.default, {
	            path: second_cta.url,
	            buttonText: second_cta.label ? second_cta.label : 'Explore'
	          })
	        )
	      ),
	      this.isPage('educator') && page_content[0].resources[0].title && _react2.default.createElement(
	        'div',
	        { className: 'content-start ' + _basicModule2.default.educatorResourcesGrid },
	        page_content[0].resources.map(function (resource, index) {
	          return _react2.default.createElement(_EducatorResource2.default, _extends({
	            key: resource.title + '-' + index
	          }, resource));
	        })
	      )
	    );
	  };
	
	  return BasicPage;
	}(_react.Component);
	
	exports.default = BasicPage;
	var exhibitionQuery = exports.exhibitionQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 871:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"basicPage":"src-templates----basic-module---basicPage---2Slcd","exiting":"src-templates----basic-module---exiting---mRxvG","introWrapper":"src-templates----basic-module---introWrapper---2rsxV","introWrapperBottom":"src-templates----basic-module---introWrapperBottom---1LYtg","educatorResourcesGrid":"src-templates----basic-module---educatorResourcesGrid---2akH8","bottomWrapper":"src-templates----basic-module---bottomWrapper---2dGJb","topWrapper":"src-templates----basic-module---topWrapper---t8_14","imageBottom":"src-templates----basic-module---imageBottom---N05U9","imageTop":"src-templates----basic-module---imageTop---cooit","loaded":"src-templates----basic-module---loaded---1KOOr","fadeInUp":"src-templates----basic-module---fadeInUp---10IS8","textEnter":"src-templates----basic-module---textEnter---1J8q6","textEnterShow":"src-templates----basic-module---textEnterShow---3iuK2","fadeIn":"src-templates----basic-module---fadeIn---2mlEZ","fadeInUpCenter":"src-templates----basic-module---fadeInUpCenter---3f3at","fadeInUpSmall":"src-templates----basic-module---fadeInUpSmall---1UmsS","textCoverIn":"src-templates----basic-module---textCoverIn---2g7n8","textCoverOut":"src-templates----basic-module---textCoverOut---3Jc5v"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-basic-js-d712638672593818f1b4.js